import { useNavigate } from "react-router-dom"
import "./work-hero.component.css"
import StrapiImageComponent from "../strapi-image/strapi-image.component"
import { daggerNavigate } from "../../utils/navigate.util"

const WorkHeroComponent = (props) => {
  const { Heading, Description, FeaturedCaseStudy } = props
  const navigate = useNavigate()

  const handleNav = () => {
    daggerNavigate(() =>
      navigate(`/study/${FeaturedCaseStudy.data.attributes.Slug}`),
    )
  }

  return (
    <div className="dagger-work-hero">
      <div className="dagger-work-hero-meta">
        <h1>{Heading}</h1>
        <p>{Description}</p>
      </div>
      <div className="dagger-work-hero-feat" onClick={handleNav}>
        <div className="dagger-work-hero-image">
          <div className="dagger-item-hint">View Work</div>
          <StrapiImageComponent
            attributes={FeaturedCaseStudy.data.attributes.HeroImage.data.attributes}
            sizes="(max-width: 800px) 100vw, 55vw"
            priority
          />
        </div>
        <h6>{FeaturedCaseStudy.data.attributes.Client}</h6>
        <h5>{FeaturedCaseStudy.data.attributes.Title}</h5>
      </div>
    </div>
  )
}

export default WorkHeroComponent
